import React from "react";

/**
 * OFFICIAL BRAND LOGO — never re-typeset the wordmark.
 * The image below is the authoritative graphic identity provided by the client:
 *  - GLOBAL (black) / AFRIQUE (red) with the central white A inside a black block
 *  - Grey globe + red arc
 *  - INTERNATIONAL wordmark
 *  - Communication & Régie tagline
 *  - Three small squares (black / red / grey) and the horizontal rules
 *
 * Rules:
 *  - Always render as <img>; do NOT re-render as text
 *  - Add `translate="no"` + `className="notranslate"` so Chrome/Safari auto-translate
 *    never converts "Global" into "Mondial(e)"
 *  - `variant="wide"` is the full horizontal signature — use in header, footer, hero,
 *    emails, commercial docs, PDF covers
 *  - `variant="mark"` still exists for tiny placements (favicon, avatar) — reserved
 *    to squares smaller than 48px where the wide signature would be unreadable
 */
export const LOGO_WIDE_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_gai-editorial/artifacts/weajjo5p_LOGO%20GAI.jpeg";
export const LOGO_URL = LOGO_WIDE_URL; // legacy alias

export default function Logo({
  size = 56,
  variant = "wide",
  withWord = false, // legacy; horizontal signature is now the default
  className = "",
  ...rest
}) {
  const mode = withWord ? "wide" : variant;

  if (mode === "mark") {
    // Small square placements only (< 48px). The wide logo remains preferred.
    return (
      <img
        src={LOGO_WIDE_URL}
        alt="GLOBAL AFRIQUE INTERNATIONAL"
        translate="no"
        className={`notranslate ${className}`}
        style={{
          height: size,
          width: size,
          objectFit: "contain",
          objectPosition: "center",
        }}
        draggable="false"
        data-testid="gai-logo-mark"
        {...rest}
      />
    );
  }

  return (
    <img
      src={LOGO_WIDE_URL}
      alt="GLOBAL AFRIQUE INTERNATIONAL — Communication & Régie"
      translate="no"
      className={`notranslate ${className}`}
      style={{
        height: size,
        width: "auto",
        maxWidth: "100%",
        objectFit: "contain",
      }}
      draggable="false"
      data-testid="gai-logo-wide"
      {...rest}
    />
  );
}
